import { useCallback } from 'react';
import { CustomVizHookDropdownOptions } from 'apps/sigma2-ui/src/lib/custom-viz/types';

export const usePayBenchmarkingFilteredCustomVizDropdowns = ({
  dropdownOptions,
}: {
  dropdownOptions: CustomVizHookDropdownOptions;
}): ((id: string) => CustomVizHookDropdownOptions) => {
  return useCallback(
    (id: string) => {
      return dropdownOptions.filter((option) => option.dropdownId === id);
    },
    [dropdownOptions],
  );
};
